var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYsafe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1657_108118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7194 17.8294H1.7317C1.3293 17.8294 1 17.5001 1 17.0977V6.48796C1 6.28674 1.16463 6.12211 1.36582 6.12211H6.27284C6.55177 6.12211 6.7827 6.31059 6.88012 6.55421L7.58538 8.31726H15.6341C16.0365 8.31726 16.3658 8.64652 16.3658 9.04892V10.82M2.82927 5.75626V1.36585C2.82927 1.16463 2.9939 1 3.19512 1H14.1707C14.3719 1 14.5365 1.16463 14.5365 1.36585V7.95137M4.53048 2.46358H12.8353M4.53048 3.92699H12.8353M8.68292 5.3904H12.8353M10.6768 6.85381H12.8353M15.3414 19.0001C20.0106 16.3347 18.8795 11.5791 18.8795 11.5791C17.9812 11.5791 16.0105 10.8813 15.3414 10.2197C14.6723 10.8813 12.7017 11.5791 11.8034 11.5791C11.8034 11.5791 10.6723 16.3347 15.3414 19.0001ZM13.4573 15.0724C13.1716 14.7867 13.1716 14.3234 13.4573 14.0377C13.7431 13.752 14.2063 13.752 14.492 14.0377L14.9223 14.468L16.1907 13.1996C16.4765 12.9138 16.9397 12.9138 17.2254 13.1996C17.5111 13.4853 17.5111 13.9485 17.2254 14.2342L15.4396 16.02C15.154 16.3057 14.6907 16.3057 14.405 16.02L13.4573 15.0724Z",
    stroke: "#7D708A",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1657_108118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYsafe);
export default __webpack_public_path__ + "static/media/ysafe.259abe5dca3386774991600b83e17228.svg";
export { ForwardRef as ReactComponent };